var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('list',{attrs:{"title":"Outros Documentos","tag":"others","subtitle":"Nesta tela você cria e verifica os templates de consultas de outros documentos.","create-route":{ name: 'Template-Other-Create' }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }